import { useCallback, useMemo } from "react";

import { SelectAllOption } from "ds/components/Table/types";
import { AiIntegrationView } from "shared/AiIntegration/useSearchAiIntegrations/gql";

import useIntegrationsAiTableSelectionStore from "./tableSelectionStore";

type UseIntegrationsAiSelectionOptionsResult = {
  selectionOptions: SelectAllOption[];
  integrationsMap: Map<string, AiIntegrationView>;
};

const useIntegrationsAiSelectionOptions = (
  integrations: AiIntegrationView[]
): UseIntegrationsAiSelectionOptionsResult => {
  const { replaceSelected } = useIntegrationsAiTableSelectionStore();

  const selectAllItems = useCallback(async () => {
    replaceSelected(integrations.map((integration) => integration.id));
  }, [replaceSelected, integrations]);

  const integrationsMap = useMemo(
    () => new Map(integrations.map((integration) => [integration.id, integration])),
    [integrations]
  );

  const selectionOptions = useMemo(
    () => [
      {
        title: "Select all integrations",
        onSelect: selectAllItems,
      },
    ],
    [selectAllItems]
  );

  return {
    selectionOptions,
    integrationsMap,
  };
};

export default useIntegrationsAiSelectionOptions;
